// extracted by mini-css-extract-plugin
export default {"grid__mobile":"UnitsContainer_grid__mobile__+6Off","unit__mobile":"UnitsContainer_unit__mobile__TwMcP"};